// Generated by psc version 0.10.2
"use strict";
var Control_Alt = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Alt.purs");
var Control_Alternative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Alternative.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Control_Apply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Apply.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Control_Monad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Monad.purs");
var Control_MonadZero = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/MonadZero.purs");
var Control_Plus = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Plus.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var MonadPlus = function (__superclass_Control$dotMonadZero$dotMonadZero_0) {
    this["__superclass_Control.MonadZero.MonadZero_0"] = __superclass_Control$dotMonadZero$dotMonadZero_0;
};
var monadPlusArray = new MonadPlus(function () {
    return Control_MonadZero.monadZeroArray;
});
module.exports = {
    MonadPlus: MonadPlus, 
    monadPlusArray: monadPlusArray
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-control/src/Control/MonadPlus.purs
// module id = 98
// module chunks = 0